import { faJournalWhills, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState } from "react";
import { Button, Form, FormGroup, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker2";
import "react-datepicker2/src/styles/style.css";
import { FileEarmarkExcelFill, PrinterFill } from "react-bootstrap-icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { exportToExcel } from "../../store/api/CommonFunctions";

const ModalDocumentCover = (props) => {
    const history = useHistory();
    const { handleSubmit, register } = useForm();
    const [pending, setPending] = useState(false);
    const searchData = useRef({});
    const { popData, setPopData } = props;
    const { show, isElectoricAccBook } = popData;
    const title = isElectoricAccBook ? "گزارش دفاتر الکترونیک" : "چاپ روکش سند حسابداری";
    function close() {
        searchData.current ={};
        setPopData({ show: false })
    }
    const tableCols = [
        { colTitle: "ردیف", colName: "DocumentNumber" },
        { colTitle: "تاریخ", colName: "PDocumentDate" },
        { colTitle: "کد حساب کل", colName: "AccountLevelTwoCode" },
        { colTitle: "عنوان حساب کل", colName: "AccountLevelTwoAccountName" },
        { colTitle: "کد حساب معین", colName: "AccLevel3Code" },
        { colTitle: "عنوان حساب معین", colName: "AccLevel3Name" },
        { colTitle: "شرح", colName: "RowDescription" },        
        { colTitle: "مبلغ بدهکار(ریال)", colName: "Debit", colType: "currency" },
        { colTitle: "مبلغ بستانکار(ریال)", colName: "Credit", colType: "currency" },
    ]
    function print(data) {
        data.PDateFrom = document.getElementsByName("DocCover_DateFrom")[0].value;
        data.PDateTo = document.getElementsByName("DocCover_DateTo")[0].value;
        if (data.PDateFrom !== "") {
            data.DateFrom = searchData.current.DateFrom;
        }
        if (data.PDateTo !== "") {
            data.DateTo = searchData.current.DateTo;
        }
        history.push({
            pathname: `/PrintViewer/DocumentCover/${data.DesignReport ?? false}`,
            state: {
                dataUrl: `api/DocumentsAPI/GetDocumentCover?dateFrom=${data.DateFrom}&dateTo=${data.DateTo}&numberFrom=${data.NumberFrom}&numberTo=${data.NumberTo}`,
                method: "get",
                fetchBody: JSON.stringify(data)
            }
        });
    }
    function toExcel() {
        const data = searchData.current;
        const url = `api/DocumentsAPI/GetDocumentCover?dateFrom=${data.DateFrom}&dateTo=${data.DateTo}&numberFrom=${data.NumberFrom}&numberTo=${data.NumberTo}`;
    // const searchArgs = {};
    //     searchArgs.Skip = 0;
    //     searchArgs.Take = 0;
        setPending(true);
        exportToExcel("ElectronicAccountBook", {}, url, "get", tableCols, () => setPending(false));
    }
    return (
        <Modal show={show} onHide={() => { }} >
            <Modal.Header className="headerStyle">
                <span><FontAwesomeIcon icon={faJournalWhills} size="lg" />&nbsp;{title}</span>
                <FontAwesomeIcon icon={faTimes} onClick={close} size="lg" />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <form onSubmit={handleSubmit(print)}>
                    <Row className="rowBorder">
                        <FormGroup className="col-md-6">
                            <label>از شماره: </label>
                            <Form.Control name="NumberFrom" ref={register({})} onChange={e => searchData.current.NumberFrom = e.target.value} />
                        </FormGroup>
                        <FormGroup className="col-md-6">
                            <label>تا شماره: </label>
                            <Form.Control name="NumberTo" ref={register({})} onChange={e => searchData.current.NumberTo = e.target.value} />
                        </FormGroup>
                        <FormGroup className="col-md-6">
                            <label>از تاریخ: </label>
                            <DatePicker className="form-control" isGregorian={false} timePicker={false} name="DocCover_DateFrom" onChange={value => searchData.current.DateFrom = value.local("en").format("YYYY-MM-DD")} />
                        </FormGroup>
                        <FormGroup className="col-md-6">
                            <label>تا تاریخ: </label>
                            <DatePicker className="form-control" isGregorian={false} timePicker={false} name="DocCover_DateTo" onChange={value => searchData.current.DateTo = value.local("en").format("YYYY-MM-DD")} />
                        </FormGroup>
                    </Row>

                    {isElectoricAccBook ?
                        <Button variant="secondary" className="group-Btn-large mt-1" disabled={pending} onClick={toExcel}><FileEarmarkExcelFill size={18} />&nbsp; ایجاد فایل گزارش</Button> :
                        <>                    <div className="form-control mt-1" style={{ background: "transparent", borderColor: "purple", fontSize: "13px", color: "blue" }}>
                            <input type="checkbox" className="form-check-input" name="DesignReport" ref={register({})} /> &nbsp;طراحی چاپ
                        </div>
                            <Button type="submit" className="group-Btn-large mt-1" disabled={pending}><PrinterFill size={18} />&nbsp; چاپ روکش سند</Button>
                        </>}

                </form>
            </Modal.Body>
        </Modal>
    )
}
export default ModalDocumentCover;